import { i18n } from "@/setup/i18n-setup";
import { getContactAddressMapPropSelectGroup } from "./contact-address-map-to-prop-select-group";
import { PropSelectGroup } from "./prop-select-group";
import { PropSelectItem } from "./prop-select-item";

export function getReminderMapPropSelectGroup(): PropSelectGroup {
	let result = new PropSelectGroup("", "", "");
	result.items.push(new PropSelectItem(i18n.t("models.map.Reminders.CreationDate"), "CreationDate"));
	let invoiceAddressMap = getContactAddressMapPropSelectGroup();
	invoiceAddressMap.name = i18n.t("models.map.Reminders.contact");
	for (let item of invoiceAddressMap.items) {
		item.value = `Contact${item.value}`;
	}
	result.groups.push(invoiceAddressMap);

	return result;
}
